import { Enumeration } from '@bp/shared/models/core/enum';

export class CrmLeadType extends Enumeration {

	static readonly partner = new CrmLeadType();

	static readonly customer = new CrmLeadType();

}
